export class RoutesMapper {
  public static readonly LOGIN: string = 'login';
  public static readonly NEW_DEPOSIT: string = 'new-deposit';
  public static readonly TRANSACTION: string = 'transaction';
  public static readonly MY_FAMILY: string = 'family-members';
  public static readonly UPDATES: string = 'updates';
  public static readonly DEPOSIT_CODES: string = 'deposit-codes';
  public static readonly MAGAZINE: string = 'magazine';
  public static readonly MAGAZINE_NEW: string = 'magazine-new';
  public static readonly MAGAZINE_HISTORY: string = 'magazine-history';
  public static readonly PRIVACY_POLICY: string = 'privacy-policy';
  public static readonly TERMS_AND_CONDITIONS: string = 'terms-and-conditions';
  public static readonly REFUND_POLICY: string = 'refund-policy';
  public static readonly TAX_CLAIM: string = 'tax-claim';
  public static readonly LANDING_PAGE: string = 'landing-page';
  public static readonly CONTACT_US: string = 'contact-us';
  public static readonly HOME: string = 'home';
  public static readonly ALL_TRANSACTION: string = 'all-transaction';
  public static readonly UPDATE_CONTACT: string = 'update-contact';
}
